/** The ZoneIn brand mark — the four priority zones. Matches favicon/app icons. */
export function Logo({ size = 36 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 512 512"
      role="img"
      aria-label="ZoneIn AI"
      className="shrink-0"
    >
      <defs>
        <linearGradient id="zonein-bg" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#4f46e5" />
          <stop offset="1" stopColor="#312e81" />
        </linearGradient>
      </defs>
      <rect width="512" height="512" rx="112" fill="url(#zonein-bg)" />
      <rect x="100" y="100" width="148" height="148" rx="36" fill="#f87171" />
      <rect x="264" y="100" width="148" height="148" rx="36" fill="#34d399" />
      <rect x="100" y="264" width="148" height="148" rx="36" fill="#fbbf24" />
      <rect x="264" y="264" width="148" height="148" rx="36" fill="#cbd5e1" opacity="0.55" />
      <path
        d="M303 176 l26 26 44 -48"
        fill="none"
        stroke="#065f46"
        strokeWidth="26"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
